module.exports = __webpack_public_path__ + "media/images/ohap_vb logo-06e46a447c2c5fc76fa1c3cf263f896f.png";